document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll("[data-ptm-carousel]");
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const track = carousel.querySelector("[data-ptm-track]");
    const prev = carousel.querySelector("[data-ptm-prev]");
    const next = carousel.querySelector("[data-ptm-next]");
    if (!track || !prev || !next) return;

    const getStep = () => {
      const firstCard = track.querySelector(".ptm-card");
      if (!firstCard) return 320;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap || "0");
      return Math.max(240, cardWidth + gap);
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: dir * getStep(), behavior: "smooth" });
    };

    prev.addEventListener("click", () => scrollByStep(-1));
    next.addEventListener("click", () => scrollByStep(1));

    // Optional: hide arrows if not scrollable (rare, but nice)
    const updateArrows = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScrollLeft - 2;

      prev.style.opacity = atStart ? "0.35" : "1";
      next.style.opacity = atEnd ? "0.35" : "1";
      prev.style.pointerEvents = atStart ? "none" : "auto";
      next.style.pointerEvents = atEnd ? "none" : "auto";
    };

    updateArrows();
    track.addEventListener("scroll", () => window.requestAnimationFrame(updateArrows));
    window.addEventListener("resize", () => window.requestAnimationFrame(updateArrows), { passive: true });
  });
});
